<section class="questionnaire-wrapper" *ngIf="init">
  <gen-overlay-loader *ngIf="loading" [showOverlay]="true" class="update-questionnaire-loader"></gen-overlay-loader>
    <gen-dynamic-form
      class="questionnaire-content"
      [disabled]="false"
      [title]="'Checklist'"
      [formVertical]="false"
      [formData]="questionnaireData"
      [formConfig]="inputConfig"
      [resetForm]="false"
      [stayInFormMode]="true"
      [editMode]="false"
      (formChange)="updateFormOnChange($event.form)"
      (validateChange)="updateValidate($event)"
      [submitted]="widgetFormInstanceSubmitted"
      [emitFormChangeEvenIfInvalid]="true"
    ></gen-dynamic-form>
    <gen-button class="Auto_Button_Form_Submit update-button"
                    (click)="saveQuestionnaireData()"
                    [type]="'primary'"
                    [text]="'Update'">
    </gen-button>
  </section>
